import { render } from "./request-password.vue?vue&type=template&id=4af296ed&scoped=true&ts=true&lang=pug"
import script from "./request-password.vue?vue&type=script&lang=ts"
export * from "./request-password.vue?vue&type=script&lang=ts"

import "./request-password.vue?vue&type=style&index=0&id=4af296ed&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af296ed"]])

export default __exports__